export default __webpack_public_path__ + "static/media/937.26de3eb4.gif";